import { render } from "./DataviewComponent.vue?vue&type=template&id=6666876c&ts=true"
import script from "./DataviewComponent.vue?vue&type=script&lang=ts"
export * from "./DataviewComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__